var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollectionVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.26758 1.07776C2.51916 1.07776 0.285156 3.30503 0.285156 6.04648C0.285156 7.67649 1.08683 9.11449 2.30469 10.0231H1.50391V10.525V12.5289H0V13.0329V16.0348H1.50391V17.5348H0V18.0387V21.0406H9.03516V18.5406H10.541V15.0367H9.03516V13.5269H10.541V10.0231H8.23438C9.45435 9.11449 10.2578 7.67649 10.2578 6.04648C10.2578 3.30503 8.016 1.07776 5.26758 1.07776ZM5.26758 2.07578C7.47486 2.07578 9.25586 3.8448 9.25586 6.04648C9.25586 8.2415 7.48511 10.0123 5.28711 10.0231H5.24805C3.0501 10.0117 1.28711 8.2415 1.28711 6.04648C1.28711 3.8448 3.0603 2.07578 5.26758 2.07578ZM2.50391 11.0288H9.54102V12.5289H9.03516H2.50391V11.0288ZM1 13.5269H8.03516V15.0367H1V13.5269ZM2.50391 16.0348H9.03516H9.54102V17.5348H9.03516H2.50391V16.0348ZM1 18.5406H8.03516V20.0426H1V18.5406Z",
    fill: "#B3B3B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.76758 3.31787V3.81988V3.99735H3.69531V6.54821H5.84766V7.1029H4.19727H3.69531V8.10092H4.19727H4.76758V8.27851V8.78041H5.77539V8.27851V8.10092H6.84766V5.55007H4.69531V4.99549H6.34375H6.84766V3.99735H6.34375H5.77539V3.81988V3.31787H4.76758Z",
    fill: "#B3B3B3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8137 0L11.4991 5.30182H12.5518H14.0123L14.0641 16.534H17.5706V5.30182H20.1282L15.8137 0ZM15.8137 1.58981L18.0303 4.30357H16.5698V15.5357H15.0575L15.0056 4.30357H13.6045L15.8137 1.58981Z",
    fill: "#B3B3B3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0641 17.5397V18.5379H14.5682H17.0591H17.5632V17.5397H17.0591H14.5682H14.0641Z",
    fill: "#B3B3B3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0641 19.5436V20.5418H14.5682H17.0591H17.5632V19.5436H17.0591H14.5682H14.0641Z",
    fill: "#B3B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectionVector);
export default __webpack_public_path__ + "static/media/CollectionVector.22ad7565c013a5c83661edb357c09618.svg";
export { ForwardRef as ReactComponent };